<kt-portlet> 
    <kt-portlet-body>
        <kt-fields-list [parentData]="moduleType" [singularData]="singularName"></kt-fields-list>
    </kt-portlet-body>
</kt-portlet>
  